import { render, staticRenderFns } from "./SwapErrorBox.vue?vue&type=template&id=2e2fe4d8&scoped=true"
import script from "./SwapErrorBox.vue?vue&type=script&lang=ts"
export * from "./SwapErrorBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2fe4d8",
  null
  
)

export default component.exports